import { IClientData } from "../../../../models/ClientData";
import { IProductDefinition } from "../../../types/journeyInput.types";
import { myPensionProductDefinition } from "../../products";

export interface IClientRootDefinition {
  products: IProductDefinition[];
}

const defaultClientRootDefinition: IClientRootDefinition = {
  products: [myPensionProductDefinition],
};

export const clientDefinitions: Record<string, IClientRootDefinition> = {
  "": defaultClientRootDefinition,
  default: defaultClientRootDefinition,
};

export function getClientRootDefinition(
  clientData: IClientData | null
): IClientRootDefinition {
  return (
    clientDefinitions[clientData?.regSrc ?? ""] ?? defaultClientRootDefinition
  );
}
